module.exports = __webpack_public_path__ + "static/two-b45cad3be1f24e0e885e23e6d7856014.mp4";